import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Skeleton from '@mui/material/Skeleton';

import PageContainer from '../../components/PageContainer';
import ModelFrontLogsTable from '../../components/ModelFrontLogsTable';
import { PageHeader, StatusChip } from '../../components/ui';

import { getModelFrontLogs } from '../../store/thunk/modelFrontLogs';
import { IStore } from '../../store/types';

const DEFAULT_QUERY_PARAMS = {
    page: 1,
    limit: 10,
};

const ModelFrontLogsPage = () => {
    const dispatch = useDispatch();

    const { data, status, queryParams } = useSelector<IStore, { data: any; status: string | null; queryParams: any }>(
        (state) => ({
            data: state.modelFrontLogs.data,
            status: state.modelFrontLogs.status,
            queryParams: state.modelFrontLogs.queryParams,
        })
    );

    const loadLogs = (params: any) => {
        dispatch<any>(getModelFrontLogs(params));
    };

    const handleChangePage = (_: unknown, newPage: number) => {
        loadLogs({ ...queryParams, page: newPage + 1 });
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        loadLogs({ ...queryParams, limit: parseInt(event.target.value, 10), page: 1 });
    };

    useEffect(() => {
        loadLogs(DEFAULT_QUERY_PARAMS);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- first load only
    }, []);

    const total = data?.totalCount ?? 0;

    return (
        <PageContainer constrained>
            <PageHeader
                eyebrow="Production"
                title="Model front logs"
                subtitle="Pillow search sessions logged by the browser model: detections, timings and search results."
                badges={status === 'succeeded' && total > 0 ? <StatusChip tone="neutral">{total.toLocaleString('en-US')} records</StatusChip> : undefined}
            />
            {status === 'loading' && !data ? (
                <Skeleton variant="rounded" width="100%" height={400} />
            ) : (
                <ModelFrontLogsTable onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
            )}
        </PageContainer>
    );
};

export default ModelFrontLogsPage;
